import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Attest } from '../interfaces/attest.interface';

@Injectable()
export class AttestService {
  constructor(
    protected http: HttpClient,
    @Inject('API_URL') protected apiUrl: string) {
  }

  public attestManyAnstallningBeslut(instance: string, anstallningId: string, beslutIds: string[]): Observable<Attest> {
    return this.http.post<Attest>(`${this.apiUrl}${instance}/attest/anstallning/${anstallningId}`, beslutIds || []);
  }

  public attestManyArendeBeslut(instance: string, arendeId: string, beslutB2Ids: string[]): Observable<Attest> {
    return this.http.post<Attest>(`${this.apiUrl}${instance}/attest/arende/${arendeId}`, beslutB2Ids || []);
  }

  public attestManyTradBeslut(instance: string, tradId: string, beslut: string[], beslutB2: string[]): Observable<Attest> {
    return this.http.post<Attest>(`${this.apiUrl}${instance}/attest/trad/${tradId}`, { 'beslut': beslut || [], 'beslutB2': beslutB2 || [] });
  }

  public attestHuvudB2(instance: string, huvudB2Id: string): Observable<Attest> {
    return this.http.get<Attest>(`${this.apiUrl}${instance}/attest/b2/${huvudB2Id}`);
  }
}
